import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'advenio-components'
import { Route, Redirect, Switch, withRouter } from 'react-router'
import { connect } from 'react-redux'
import { AuthRedux } from 'auth-advenio'

import Login from './Auth/Login'
import ResetPassword from './Auth/ResetPassword'
import SetNewPassword from './Auth/SetNewPassword' // TODO: Replace with component from 'auth-advenio'
import AppContainer from './AppContainer'
import LoadingSpinner from '../Components/LoadingSpinner'

class AuthContainer extends Component {
  componentWillMount() {
    const {
      checkAuthStatus,
      location,
      logOut,
    } = this.props

    if (location.pathname === '/logout') {
      logOut()
    }

    checkAuthStatus()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }

  getRoute = (authenticated, authorized) => {
    if (authenticated && authorized) {
      return <Route path="/" component={AppContainer} />
    } else if (authenticated === false) {
      return (
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/recover-password" component={ResetPassword} />
          <Route exact path="/reset/:token" component={SetNewPassword} />
          <Route render={() => <Redirect to="/login" />} />
        </Switch>
      )
    }

    return <LoadingSpinner />
  }

  render() {
    const { loading, impersonating } = this.props
    return (
      <div>
        <Switch>
          {this.getRoute(this.props.authenticated, this.props.authorized)}
        </Switch>
        {loading && impersonating &&
          <Modal isOpened loading />
        }
      </div>
    )
  }
}

AuthContainer.propTypes = {
  /** Function to check the user's current authentication status */
  checkAuthStatus: PropTypes.func.isRequired,
  /** Flag marking whether the user is currently authenticated */
  authenticated: PropTypes.bool,
  /** Flag marking whether the user is authorized to access this platform */
  authorized: PropTypes.bool,
  /** Loading flag */
  loading: PropTypes.bool,
  /** Flag marking whether the user is currently impersonating another user type */
  impersonating: PropTypes.bool,
  /** Log out of the platform */
  logOut: PropTypes.func.isRequired,
}

AuthContainer.defaultProps = {
  authenticated: null,
  authorized: null,
  loading: false,
  impersonating: false,
}

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
  authorized: auth.authorized,
  loading: auth.fetching,
  impersonating: auth.user && auth.user.is_impersonating,
})

const mapDispatchToProps = dispatch => ({
  checkAuthStatus: () => dispatch(AuthRedux.Actions.checkAuthStatus()),
  logOut: () => dispatch(AuthRedux.Actions.logout({ shouldDeleteCookies: true })),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthContainer))



// WEBPACK FOOTER //
// ./src/Containers/AuthContainer.jsx